import { conditionCategoryApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONDITION_CATEGORIES_ACTION_TYPE = createNamedActions('conditionCategories', {
  GET_CONDITION_CATEGORIES: 'GET_CONDITION_CATEGORIES',
  ADD_CONDITION_CATEGORY: 'ADD_CONDITION_CATEGORY',
  UPDATE_CONDITION_CATEGORY: 'UPDATE_CONDITION_CATEGORY',
  DELETE_CONDITION_CATEGORY: 'DELETE_CONDITION_CATEGORY',
});

export const getConditionCategoriesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionCategoryApi.getConditionCategories();

  return dispatch({
    type: CONDITION_CATEGORIES_ACTION_TYPE.GET_CONDITION_CATEGORIES,
    payload: data ?? [],
  });
});

export const addConditionCategoryAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await conditionCategoryApi.createConditionCategory(body);

  return dispatch({
    type: CONDITION_CATEGORIES_ACTION_TYPE.ADD_CONDITION_CATEGORY,
    payload: data,
  });
});

export const updateConditionCategoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await conditionCategoryApi.updateConditionCategory(params);

  return dispatch({
    type: CONDITION_CATEGORIES_ACTION_TYPE.UPDATE_CONDITION_CATEGORY,
    payload: data,
  });
});

export const deleteConditionCategoryAction = catchAsyncActionError(
  ({ conditionCategoryId }) =>
    async dispatch => {
      await conditionCategoryApi.deleteConditionCategory({ conditionCategoryId });

      return dispatch({
        type: CONDITION_CATEGORIES_ACTION_TYPE.DELETE_CONDITION_CATEGORY,
        payload: conditionCategoryId,
      });
    },
);
